import { ApiQueryParams } from '../types/ApiQueryParams';
import { fetchFromLambda } from '@agyletime/vue-3-common/src/utils/apiService';
import { transformDateIntoLocalString } from '@/utils/date';
import { ApiRespAssignmentAgeBandsByWorkload } from '../types/AssignmentMetricsResponse';

export const fetchAssignmentAgeBandsByWorkloads = async (
    queryParams: ApiQueryParams
): Promise<ApiRespAssignmentAgeBandsByWorkload> => {
    const params = new URLSearchParams({
        fromDate: transformDateIntoLocalString(queryParams.fromDate),
        toDate: transformDateIntoLocalString(queryParams.toDate),
        workstreamDefinitionIds: queryParams.workstreamDefinitionIds.join(',')
    });

    return await fetchFromLambda(`/workactivity/back-office/assignment/snapshot/age-bands/workloads?${params}`);
};